import React from 'react';
import './propTypes.js';
import Type from './Type.js';

const H2 = props => /*#__PURE__*/React.createElement(Type, props, props.children);
H2.defaultProps = {
  tag: 'h2',
  font: 'h2'
};

export { H2 as default };
